import { type FC, useContext, useEffect } from 'react';

import { useCountDownTimer } from '@/common/hooks/count-down-timer';
import { useGetContracts } from '@/common/hooks/request-for-get-contracts';
import { ModalContext } from '@/components/Modals/Modal/config';
import { selectSpecContractDataByKind } from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

const ContractTimersHandler: FC = () => {
  const { closeModal } = useContext(ModalContext);
  const getContracts = useGetContracts();
  const goldenContract = useAppSelector((state) =>
    selectSpecContractDataByKind(state, 'Golden'),
  );
  const nextGoldContractTime = useAppSelector(
    (state) => state.contract.nextGoldContractTime,
  );
  const nextCustomContractTime = useAppSelector(
    (state) => state.contract.nextCustomContractTime,
  );
  const nextGoldContractSeconds = useCountDownTimer(
    nextGoldContractTime ? nextGoldContractTime / 1000 : 0,
  );
  const nextCustomContractSeconds = useCountDownTimer(
    nextCustomContractTime ? nextCustomContractTime / 1000 : 0,
  );
  const seconds = useCountDownTimer(
    (goldenContract?.timeLeft || 0) < 0
      ? 0
      : (goldenContract?.timeLeft as number) / 1000,
  );

  useEffect(() => {
    if (
      (nextGoldContractTime && nextGoldContractSeconds < 0) ||
      (nextCustomContractTime && nextCustomContractSeconds < 0) ||
      seconds < 0
    ) {
      closeModal();
      getContracts();
    }
  }, [nextGoldContractSeconds, nextCustomContractSeconds, seconds]);

  return null;
};

export { ContractTimersHandler };
